module.exports = __webpack_public_path__ + "img/offeo-6.0e54e9f3.png";